import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import JSGroupEventCodeSnippet from "../\_snippets/capture-group-event-code.mdx";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const MultiLanguage = makeShortcode("MultiLanguage");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`In our client-side SDKs, any event captured after calling `}<inlineCode parentName="p">{`posthog.group`}</inlineCode>{` will automatically be linked to the group during that session.`}</p>
    <p>{`To link an event to a group in our server-side SDKs or API, set the key-value pair `}<inlineCode parentName="p">{`<group type>: <group_id>`}</inlineCode>{` to the `}<inlineCode parentName="p">{`groups`}</inlineCode>{` property of the event.`}</p>
    <p>{`Below are code examples of how to do it in our various SDKs. Notice that it is the exact same code as creating a group.`}</p>

    <JSGroupEventCodeSnippet mdxType="JSGroupEventCodeSnippet" />
    <p>{`Note that it is `}<strong parentName="p">{`NOT`}</strong>{` possible to assign the a single event to two groups of the same type. However, it is possible to assign an event to multiple groups as long as the groups are of different types.`}</p>
    <MultiLanguage mdxType="MultiLanguage">
      <pre><code parentName="pre" {...{
          "className": "language-js-web"
        }}>{`// ❌ Not possible
posthog.group('company', 'company_id_in_your_db');
posthog.group('company', 'another_company_id_in_your_db');
posthog.capture('user_signed_up')

// ✅ Allowed
posthog.group('company', 'company_id_in_your_db');
posthog.group('channel', 'channel_id_in_your_db');
posthog.capture('user_signed_up')

`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-python"
        }}>{`# ❌ Not possible
posthog.capture(
    '[user distinct id]',
    'user_signed_up',
    groups={
        'company': 'company_id_in_your_db',
        'company': 'another_company_id_in_your_db'
    }
)

# ✅ Allowed
posthog.capture(
    '[user distinct id]',
    'user_signed_up',
    groups={
        'company': 'company_id_in_your_db',
        'channel': 'channel_id_in_your_db'
    }
)
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-go"
        }}>{`// ❌ Not possible
client.Enqueue(posthog.Capture{
    DistinctId: "[user distinct id]",
    Event: "user_signed_up",
    Groups: posthog.NewGroups().
        Set("company", "company_id_in_your_db").
        Set("company", "another_company_id_in_your_db").
})

// ✅ Allowed
client.Enqueue(posthog.Capture{
    DistinctId: "[user distinct id]",
    Event: "user_signed_up",
    Groups: posthog.NewGroups().
        Set("company", "company_id_in_your_db").
        Set("channel", "channel_id_in_your_db").
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-node"
        }}>{`// ✅ Allowed
posthog.capture({
    event: 'user_signed_up',
    distinctId: '[user distinct id]',
    groups: { 
        company: 'company_id_in_your_db',
        channel: 'channel_id_in_your_db'
    }
})
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-php"
        }}>{`// ❌ Not possible
PostHog::capture(array(
    'distinctId' => '[user distinct id]',
    'event' => 'user_signed_up',
    '$groups' => array("company" => "company_id_in_your_db", "company" => "another_company_id_in_your_db")
));
// ✅ Allowed
PostHog::capture(array(
    'distinctId' => '[user distinct id]',
    'event' => 'user_signed_up',
    '$groups' => array("company" => "company_id_in_your_db", "channel" => "channel_id_in_your_db")
));
`}</code></pre>
    </MultiLanguage>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      